import { render, staticRenderFns } from "./my-appoint.vue?vue&type=template&id=96bcf724&scoped=true&"
import script from "./my-appoint.vue?vue&type=script&lang=js&"
export * from "./my-appoint.vue?vue&type=script&lang=js&"
import style0 from "./my-appoint.vue?vue&type=style&index=0&id=96bcf724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bcf724",
  null
  
)

component.options.__file = "my-appoint.vue"
export default component.exports